export const GLOBAL_BASE_URL = process.env.GLOBAL_FACADE_SERVER_ADDRESS
export const HELP2PAY_LINK = process.env.help2PayLink

//===========================================store function api=========================================
export const EP_REGISTER_EMAIL_VERIFY                   =               '/v2/create/register/verify/email/otp'
export const EP_SEND_EMAIL_OTP                          =               '/v2/create/register/send/email/otp'
export const EP_USER_LOGIN 			    				= 				'/api/login'
export const EP_USER_LOGIN_2FA			    			= 				'/api/login/twofa'
export const EP_USER_SIGNUP 		    				= 				'/api/create/lead'
export const EP_VERIFY_LEAD_OTP         				=				'/api/verify/otp/lead'
export const EP_USER_FORGOT_PASSWORD         			=				'/forgot/password'
export const EP_ADMIN_LOGOUT 							= 				'/signout'
export const EP_GENERATE_2FA_QRCODE         			=				'/sa/generate/twofa/qrcode'
export const EP_VERIFY_2FA_QRCODE         				=				'/sa/verify/twofa/secret'
export const EP_DISABLE_2FA_QRCODE						=				'/sa/disable/twofa'
export const EP_SAVE_USER_NAME 							=				'/sa/add/username'
export const EP_REGISTER_STEP1 							=				'/v2/create/register/step/one'
export const EP_REGISTER_STEP2 							=				'/v2/create/register/step/two'
export const EP_REGISTER_STEP3 							=				'/sa/create/register/step/three'
export const EP_REGISTER_STEP4 							=				'/sa/create/register/step/four'
export const EP_REGISTER_STEP5 							=				'/sa/create/register/step/five'
export const EP_DELETE_DOC 							    =				'/sa/delete/user/docs'
export const EP_SKIP_DOCUMENT_UPLOAD 					=				'/sa/skip/document/upload/step/five'
export const EP_GET_QUESTION_ANSWER     				=				'/v2/get/question_answer'
export const EP_GET_COUNTRIES_LIST      				=				'/sa/get/country/list'
export const EP_GET_CITIES_LIST         				=				'/sa/get/city/list'
export const EP_GET_SUM_SUB_RESPONSE         			=				'/get/user/ipv/details'
export const EP_RESOLVE_DOC_ISSUE         				=				'/resolve/user/ipv/details'
export const EP_LANGUAGE_API         					=				'/update/default/language'
export const EP_SAVE_FIREBASE_TOKEN         			=				'/save/firebase/token'
export const EP_GET_ACCOUNT_PRIORITY_LIST				=				'/trading/account/priority'
export const EP_BANK_DEPOSIT_FOR_FEW_COUNTRIES			=				'/get/gatech/url'
//===========================================plugin function api=========================================
export const EP_GET_WEBINAR_DATA						=				'/get/webinar/blog'
export const EP_GET_POST_DATA							=				'/get/posts'

export const EP_GET_AUTOCHARTIST_DATA 					=				'/get/autochartist/data'
export const EP_GET_AUTO_CHARTIST_WEB_URL				=				'/get/autochartist/url'
export const EP_GET_SIGNAL_CENTRE_DATA 					=				'/get/signal-centre/data'
export const EP_GET_ECONOMIC_CALENDER_DATA 				=				'/get/calendar'
export const EP_GET_CALENDER_EVENT						=				"/get/ticker/history"
export const EP_GET_CURRENT_NEWS 						=				'/get/news'
export const EP_GET_CURRENT_NEWS_DETAIL					=				'/fxstreet/post/details'
export const EP_GET_COUPON_LIST 						=				'/get/coupon/list'
export const EP_CHECK_COUPON_VALIDITY					=				'/check/coupon/code'
export const EP_REQUEST_CALLBACK						=				'/client/create/admin/task'


export const EP_COUPON_PLAN 							=				'/get/plan/coupons'
export const EP_GET_SUB_PLAN_LIST 						=				'/subscription/plan/list'
export const EP_GET_SUB_PLAN_DETAIL 					=				'/subscription/plan/detail'
export const EP_SUB_OPERATION_LINK 						=				'/subscription/operations/link'
export const EP_SUB_OPERATION							=				'/subscription/operations'
export const EP_CREATE_SUB_TICKET						=				'/create/subscription'
export const EP_UNSUB_SERVICE							=				'/end/subscription'

export const EP_GET_VPS_LIST 							=				'/user/server/list'
export const EP_GET_VPS_DETAIL 							=				'/user/server/details'
export const EP_VPS_RESTART 							=				'/vps/server/on'
export const EP_VPS_REBOOT								=				'/vps/server/reboot'
export const EP_VPS_SHUTDOWN							=				'/vps/server/off'
export const EP_VPS_CHANGE_PASSWORD						=				'/vps/server/reset/password'

export const EP_CREATE_ACCOUNT 							=				'/create/account'
export const EP_DEMO_DEPOSIT 							=				'/deposit/demo/account'

export const EP_CREATE_PAMM_ACCOUNT 					=               '/create/pamm/account'
export const EP_GET_IB_MAMM_UNSIGNED_AGREEMENT			=				'/get/ibmamm/unsigned/agreement'
export const EP_SAVE_IB_MAMM_DISCLAIMER     			=				'/save/ibmamm/disclaimer'

export const EP_TRADING_BONUS 							=				'/get/allowed/bonus'
export const EP_BONUS_REQUEST_OTP 						=				'/bonus/otp'
export const EP_BONUS_CHECK_OTP 						=				'/add/bonus'
export const EP_GET_BONUS_LIST 							=				'/get/bonus/list'
export const EP_REMOVE_BONUS 							=				'/remove/bonus'
export const EP_RESEND_EMAIL_LINK_BONUS 				= 				'/account/operations/link'

export const EP_TICKET_REQUEST_OTP 						=				'/ticket/request/otp'
export const EP_TICKET_CHECK_OTP 						=				'/ticket/request'
export const EP_GET_TICKET_LIST 						=				'/list/ticket'
export const EP_GET_TICKET_DETAIL 						=				'/ticket/details'
export const EP_TICKET_REPLY							=				'/create/ticket/thread'
export const EP_GET_TICKET_REASON_LIST					=				'/get/ticket/reasons'
export const EP_TICKET_RESEND_OTP						=				'/ticket/request/otp/resend'

export const EP_ACCOUNT_PASSWORD_REQUEST_OTP 			=				'/account/operations'
export const EP_ACCOUNT_PASSWORD_CHECK_OTP 				=				'/account/change/password'
export const EP_ACCOUNT_LEVERAGE_CHECK_OTP 				=				'/change/leverage'
export const EP_INTERNAL_TRANSFER_CHECK_OTP 			=				'/internal/transfer'
export const EP_RUN_ADD_LAST_SELECT_TRADING_ACCOUNT 	=				'/trading/account/history'
export const EP_RESEND_EMAIL_LINK_ACCOUNTS 				= 				'/account/operations/link'
export const EP_AMOUNT_CONVERSION_API 					= 				'/currency/converter'

export const EP_WITHDRAWAL_REQUEST_OTP					=				'/withdrawal/request/otp'
export const EP_WITHDRAWAL_CHECK_OTP					=				'/withdrawal/request'
export const EP_RESEND_EMAIL_LINK 						= 				'/withdrawal/request/resend/otp'
export const EP_GET_WITHDRAWAL_METHODS 					= 				'/get/withdrawal/methods'
export const EP_GET_WITHDRAWAL_DESC 					=				'/get/withdrawal/desc'

export const EP_GET_USER_CAN_DEPOSIT 					= 				'/get/deposit/methods'
export const EP_TRANS_LIMIT_CURRENCY 					= 				'/get/deposit/limit'
export const EP_GET_TRANSACTION_STATUS 					= 				'/get/transaction/status'

export const EP_GET_TRADING_ACCOUNT_LIST 				=				'/get/trading/account/list'
export const EP_CREATE_API_SUBSCRIPTION 				=				'/create/api/subscription'
export const EP_GET_DEPOSIT_LIST       					=				'/get/deposit/list'
export const EP_CREDIT_CARD_DEPOSIT 					=				'/get/deposit/url'
export const EP_CRYPTO_DEPOSIT 							=				'/deposit/request/operations' //'/get/wallet/url'


export const EP_GET_WITHDRAWAL_LIST     				=				'/get/withdrawal/list'
export const EP_GET_TRADING_ACCOUNT_DETAILS         	=				'/get/account/details'

export const EP_GET_PROFIT_CHART_DATA         			=				'/get/profit/data'
export const EP_GET_BALANCE_DATA         				=				'/get/balance/data'
export const EP_GET_EQUITY_DATA         				=				'/get/equity/data'
export const EP_GET_TRADING_DATA         				=				'/get/trading/data'
export const EP_GET_IDENFY_TOKEN  						= 				'/get/idenfy/token'

export const EP_ADD_BANK         						=				'/add/bank/account'
export const EP_GET_BANK_LIST         					=				'/get/bank/accounts'

export const EP_GET_USER_PROFILE 						= 				'/sa/get/user/profile'
export const EP_GET_USER_REGISTERATION_STEP_DATA 		= 				'/v2/get/registration/data'
export const EP_USER_NOTIFICATIONS 						= 				'/common/get/notifications'

export const EP_RESET_PASSWORD_FROM_HASH 				=   			'/change/via/forgot/password'

export const EP_CHANGE_PASSWORD 						=   			'/change/password'
export const EP_REFER_Friend							=   			'/save/referall/email'
export const EP_REFER_LIST								=   			'/get/referall/List'
export const EP_REFER_DELETE							=   			'/delete/referall/List'
export const EP_GET_AUTOCHARTIST_URL					=   			'/get/autochartist/url1'
export const EP_CONVERT_WALLET_BALANCE					=   			'/api/convert/wallet/balance'
export const EP_GET_HOOPS_DATA							=   			'/get/hoops/data'

//wallet
export const EP_CREATE_WALLET_ACCOUNT					=				'/create/wallet'
export const EP_GET_WALLET_DETAIL						=				'/get/wallet/details'
export const EP_GET_WALLET_TRANSACTION					=				'/get/wallet/transactions'
export const EP_GET_WALLET_BALANCE						=				'/get/wallet/balance'
export const EP_SWIFFY_DETAILS						    =				'/swiffy/request'

export const EP_HELP2PAY_PAYMENTINFO				    =			    '/help2pay/paymentInfo'

export const EP_HELP2PAY_DETAILS						=			    '/help2pay/request'
export const EP_HELP2PAY_CURRENCY_CONVERSION			=			    '/help2pay/currencyConversion'
export const EP_ALL_CURRENCY_LIST                       =               '/help2pay/currencyList'

export const EP_GET_PAYMENTASIA_DETAILS					=			    '/paymentasia/get/request'
export const EP_VERTUPAY_DETAILS						=			    '/vertupay/get/payment_url'

export const EP_PAYGURU_DETAIL						    =			    '/payguru/request'
export const EP_ASTROPAY_DETAILS						=			    '/astropay/request'
export const EP_PERFECT_MONEY_DETAILS					=			    '/api/v1/perfectmoney/request'
export const EP_NUVEI_DETAILS					        =			    '/nuvei/request'
export const EP_KORAPAY_DEPOSIT					        =			    '/korapay/request'
export const EP_KORAPAY_CURRENCY_LIST					=			    '/korapay/currency/list'
export const EP_GET_TRUST_PAY_DETAILS					=			    '/trustpay/request'


//loyality
export const EP_GET_LOYALITY_CARD_DETAIL				=				'/loyalty/card/details'
export const EP_GET_LOYALITY_TXN_LIST					=				'/loyalty/transaction/list'
export const EP_LOYALITY_REQUEST_OTP					=				'/loyalty/points/transaction'
export const EP_LOYALITY_REDEEM_CHECK_OTP				=				'/redeem/loyalty/points'
export const EP_LOYALITY_TRANSFER_CHECK_OTP				=				'/transfer/loyalty/points'
export const EP_LOYALITY_EMAIL_VERIFY_LINK				=				'/loyalty/points/transaction/link'

export const EP_GET_SUBSCRIPTION_DETAIL					=				'/subscription/transaction/list'
export const EP_SUBSCRIPTION_REQUEST_OTP				=				'/update/subscription/payment/transaction'
export const EP_SUBSCRIPTION_CHECK_OTP					=				'/update/subscription/payment'
export const EP_SUBSCRIPTION_RESEND_EMAIL_LINK			=				'/update/subscription/payment/transaction/link'


export const EP_UNSUBSCRIBE_REQUEST_OTP					=				'/unsubscribe/transaction'
export const EP_UNSUBSCRIBE_CHECK_OTP					=				'/unsubscribe/request'
export const EP_Unsubscribe_RESEND_EMAIL_LINK			=				'/unsubscribe/transaction/link'

export const EP_LOYALITY_SUBSCRIP_VERIFY 				= 				'/create/loyalty/vps/subscription'

export const EP_TUT_COURSE_CATEGORY 					= 				'/get/tutorial/course_category'
export const EP_GET_VIDEO_TUTORIAL 						=				'/get/tutorial'

export const EP_GET_NOTIFICATION_LIST 					= 				'/common/get/notification'
export const EP_READ_UNREAD_NOTIFICATION 				= 				'/common/update/unread/notification/as/read'

export const EP_GET_PRAXIS_URL 							= 				'/praxis/request'
export const EP_BITCOIN_CONVERSION						=				'/get/currency/conversion'

export const EP_GET_CRYPTO_Methods						=				'/get/crypto/method'
export const EP_ADD_CRYPTO_Methods						=				'/add/crypto/method'

export const EP_UPDATE_FIRST_DEPOSIT					=				'/update/first/deposit'

//cancel withdrawal request
export const EP_CANCEL_WITHDRAWAL_REQUEST				=				`/cancel/withdrawal/request`


export const EP_ASTROPAY_AFFILIATE_LOGIN				=				`/astropay/affiliate/login`
export const EP_ASTROPAY_CURRENCY_CONVERSION		    =			    '/astropay/currency-conversion'
export const EP_FINANCIAL_DETAILS                       =               '/request/master/data'
export const EP_CHOOSE_DEMO_LIVE                        =               '/v2/trading/account/type/selection'

















// WEBPACK FOOTER //
// ./src/store/api/endpoints.js